<!-- Footer HTML Start -->
<footer class="footer-hld b5containeradjust" id="forhide">
  <div class="container">
    <div class="d-flex align-items-center flex-wrap footercontainer">
      <div class="col-md-2 mb-md-0 mb-3 footlogo px-3">

       <app-logo></app-logo>
      </div>
      <div class="col-md-10 ps-md-0">
        <p class=" text-start">Copyright © {{currentYear}} | All rights reserved. Sanlam Life Insurance Limited is a
          Licensed Financial Services Provider and a Registered Credit Provider.</p>
      </div>
    </div>
  </div>
</footer>